import { IconMail, IconPhoneCall } from "@tabler/icons-react";
import whatsappbtn from "../images/whatsapp/WhatsAppButtonGreenLarge.svg";

function Footer() {
  return (
    <>
      <footer>
        <div className="container">
          <div className="footer-content">
            <ul className="footer-content__1">
              <li>
                <span>CAR</span> Rental
              </li>
              <li>
                We offer a range of vehicles for all your driving needs. We
                have the perfect car to meet your needs.
              </li>
              <li>
                <a href="tel:+639153559915">
                  <IconPhoneCall /> &nbsp; (63) -915-355-9915
                </a>
              </li>

              <li>
                <a
                  href="mailto: 
                info@quiridepalawan.com"
                >
                  <IconMail />
                  &nbsp; info@quiridepalawan.com
                </a>
              </li>

              <li>
                <a aria-label="Chat on WhatsApp" href="https://wa.me/639153559915"> 
                <img alt="Chat on WhatsApp" src={whatsappbtn}/>
                </a>              
              </li>

              {/* <li>
                <a
                  style={{ fontSize: "14px" }}
                  target="_blank"
                  rel="noreferrer"
                  href="https://github.com/stazrouti/"
                >
                  Design by Scolofix
                </a>
              </li> */}
            </ul>

            {/* <ul className="footer-content__2">
              <li>Company</li>
              <li>
                <a href="#home">New York</a>
              </li>
              <li>
                <a href="#home">Careers</a>
              </li>
              <li>
                <a href="#home">Mobile</a>
              </li>
              <li>
                <a href="#home">Blog</a>
              </li>
              <li>
                <a href="#home">How we work</a>
              </li>
            </ul> */}

            <ul className="footer-content__2">
              <li>Working Hours</li>
              <li>We are open 24/7</li>
              {/* <li>Working Hours</li>
              <li>Mon - Fri: 9:00AM - 9:00PM</li>
              <li>Sat: 9:00AM - 19:00PM</li>
              <li>Sun: Closed</li> */}
            </ul>

            {/* <ul className="footer-content__2">
              <li>Subscription</li>
              <li>
                <p>Subscribe your Email address for latest news & updates.</p>
              </li>
              <li>
                <input type="email" placeholder="Enter Email Address"></input>
              </li>
              <li>
                <button className="submit-email">Submit</button>
              </li>
            </ul> */}
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
